import React, { useEffect, useRef, useState } from 'react';
import Navbar from '../components/Navbar';
import Footer from '../components/Footer';

function AnimatedLine({ text }) {
  const [visible, setVisible] = useState(false);
  const lineRef = useRef(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            setVisible(true);
          } else {
            setVisible(false);
          }
        });
      },
      { threshold: 0.8 }
    );

    if (lineRef.current) observer.observe(lineRef.current);
    return () => observer.disconnect();
  }, []);

  return (
    <p
      ref={lineRef}
      className="text-2xl sm:text-3xl lg:text-4xl font-medium leading-snug transition-colors duration-500"
      style={{ color: visible ? '#d1d5db' : '#111827' }} 
    >
      {text}
    </p>
  );
}

function About() {
  const lines = [
    "PT Redoura Prima Indonesia is insurance, risk management and consulting services company offering clients and customers innovation and tenacity",
    "We named our company after one of the highest mountain in Papua, Indonesia, Redoura.",
    "A symbol of strength, achievements, boldness, high, stability, commitment and pride.",
    "We aim to transform those symbols and spirits into our corporate culture and commitment to a highest standard of services quality to our valued customers/clients.",
    // "with deep expertise across insurance solutions,",
    // "we're putting the world's top products and services",
    // "into the hands of successful businesses and individuals.",
  ];

  return (
    <div className="bg-[#0e1e52]">

      <Navbar />

      <section className="pt-32 pb-24 px-4">
        <div className="max-w-7xl mx-auto">

          {/* Headline */}
          <h2 className="text-3xl sm:text-4xl lg:text-5xl font-bold text-zinc-50 mb-16">
            Expert Advice. Trusted Support. Professional Services.
          </h2>

          {/* Full width image */}
          <div className="w-full h-[500px] sm:h-[600px] rounded-2xl overflow-hidden mb-24">
            <img
              src='/image/mt-redoura.jpg'
              alt="Redoura"
              className="w-full h-full object-cover"
            />
          </div>

          {/* Meet Redoura + animated text */}
          <div className="max-w-4xl">

            <p className="font-mono text-xs tracking-[0.25em] text-[#ce381b] uppercase mb-6">
              Meet Redoura
            </p>


            <div className="space-y-2">
              {lines.map((line, i) => (
                <AnimatedLine key={i} text={line} />
              ))}
            </div>

          </div>

        </div>
      </section>

      <Footer />
    </div>
  );
}

export default About;